import { db } from '@/utils/Firebase'

const CACHE_TTL = 5 * 60 * 1000
let cache = { companyId: null, at: 0, data: null }

export const fetchCompanyStats = async (companyId, force = false) => {
    if (!companyId) return null
    if (!force && cache.companyId === companyId && (Date.now() - cache.at) < CACHE_TTL) return cache.data

    try {
        const doc = await db.collection('companyStats').doc(companyId).get()
        cache = { companyId, at: Date.now(), data: doc.exists ? doc.data() : null }
    } catch (error) {
        console.log('fetchCompanyStats error', error)
        cache = { companyId, at: Date.now(), data: null }
    }
    return cache.data
}
